/** Price movers since the previous observation. Prop-driven, no fetching. */
import type { FlightMover } from '../../types/flights';
import { hasStopover } from '../../../../server/lib/flight-shape.ts';
import { carrierLabel } from './carrierLabel';

export interface FlightMoversListProps {
  movers: FlightMover[];
  threshold: number;
}

export function FlightMoversList({ movers, threshold }: FlightMoversListProps) {
  if (movers.length === 0) {
    return (
      <p className="text-sm text-gray-500">
        No changes ≥ {threshold} since the previous observation.
      </p>
    );
  }
  return (
    <ul className="space-y-1.5">
      {movers.map((m) => {
        const up = m.delta > 0;
        const label = carrierLabel(m.carrier);
        return (
          <li key={m.id} className="flex flex-wrap items-baseline gap-2 text-sm">
            <span
              className={`font-mono font-semibold whitespace-nowrap ${up ? 'text-red-600' : 'text-emerald-600'}`}
            >
              {up ? '▲' : '▼'} {up ? '+' : ''}
              {Math.round(m.delta)}
            </span>
            <span className="font-mono whitespace-nowrap">
              {m.origin} → {m.destination}
            </span>
            <span className="font-mono" title={label.title}>
              {label.text}
            </span>
            <span className="whitespace-nowrap">
              {m.outbound_date}
              {m.inbound_date ? ` → ${m.inbound_date}` : ' (oneway)'}
            </span>
            {hasStopover(m) && (
              <span className="text-xs text-amber-700">via {m.stopover_point}</span>
            )}
            <span className="text-xs text-gray-500 whitespace-nowrap">
              {m.currency} {Math.round(m.previous_price)} → {Math.round(m.price ?? 0)}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
